module.exports = __webpack_public_path__ + "static/media/opakowania_01_C.6f1d4824.png";